define('drops/clock/clock',[
    'jquery',
    'lq/drop',
    'lq/style',
    'globalize',
    'lq/util'
], function ($, Drop, Style, globalize, util) {
    'use strict';

    var defaults = {
        data: {
            format: 'HH:mm'
        }
    };

    function Clock(options) {
        Drop.call(this, $('<div/>'), defaults, options);
        var self = this;

        self.$timeField = $('<div/>')
            .addClass('drop-text-content')
            .css({
                display: 'flex',
                flexDirection: 'column',
                flex: '1 1 100%'
            })
	        .appendTo(self.$element);

        var style = util.convertListOfKeyValuesToObject(self.data.styles);

        Style.renderStyles(self);

        var fontSize = style && style.normal && style.normal.font && style.normal.font.size
			|| Style.getDefaults().font.size;

        self.$element
	        .addClass('boxToBorderSize drop-text-container')
	        .css({                
	            display: 'flex'
	        });       

        self.update();

        return self;
    };

    Drop.extend(Clock, Drop);

    Clock.typeName = 'Clock';

    Clock.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    Clock.prototype.update = function () {
        var dateTimeString = globalize.format(new Date(), this.data.format);
        this.$timeField.text(dateTimeString);

        var self = this;
        setTimeout(function () { self.update(); }, 1000 - (new Date().getTime() % 1000));
    };

    return Clock;
});
